import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { take } from 'rxjs';
import { CouponModel } from '../../../models/coupon.model';
import { AlertService } from '../../../services/alert.service';
import { CouponService } from '../../../services/coupon.service';

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrl: './coupons.component.scss',
  standalone: false,
})
export class CouponsComponent implements OnInit {
  public isLoading = true;
  public coupons: CouponModel[] = [];
  constructor(
    private couponService: CouponService,
    private alertService: AlertService,
    private dialogService: DialogService
  ) {}

  public ngOnInit(): void {
    this.couponService
      .getAllSellableCoupons()
      .pipe(take(1))
      .subscribe({
        next: coupons => {
          this.coupons = coupons;
          this.isLoading = false;
        },
        error: error => {
          console.error(error);
          this.alertService.showErrorAlert('Fehler beim Laden der Gutscheine');
          this.isLoading = false;
        },
      });
  }
}
